import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, BookOpenText, Instagram, Sparkles, Users } from "lucide-react";
import { CARD_STORY, COMMUNITY_TABLE, PILLAR_RETE, PILLAR_VISIBILITA, PILLAR_SOSTEGNO } from "@/data/media";

const SEZIONI = [
  {
    to: "/manifesto",
    icon: Sparkles,
    kicker: "Chi siamo",
    titolo: "Il manifesto",
    testo: "I quattro valori della rete: rete, visibilità, sostegno, innovazione.",
    image: PILLAR_SOSTEGNO,
  },
  {
    to: "/community",
    icon: Users,
    kicker: "Le socie",
    titolo: "La community",
    testo: "Voci, obiettivi ed esperienze delle imprenditrici che guidano altre donne.",
    image: COMMUNITY_TABLE,
  },
  {
    to: "/racconta-la-tua-storia",
    icon: BookOpenText,
    kicker: "Partecipa",
    titolo: "Raccontaci la tua storia",
    testo: "Il modulo per proporre il tuo percorso e pubblicarlo nella community.",
    image: CARD_STORY,
  },
  {
    to: "/social",
    icon: Instagram,
    kicker: "Social",
    titolo: "Dal nostro Instagram",
    testo: "Gli ultimi post del profilo Instagram di DonnaImpresa, sempre aggiornati.",
    image: PILLAR_VISIBILITA,
  },
];

export const SectionsIndex = () => (
  <section
    className="mx-auto max-w-[1400px] px-5 py-16 sm:px-10 sm:py-20"
    data-testid="sections-index"
    aria-label="Sezioni del sito"
  >
    <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#E0708A]">
      Esplora
    </p>
    <h2 className="mt-4 max-w-2xl font-display text-3xl leading-tight tracking-tight text-[#1A1617] sm:text-4xl">
      Cosa trovi
      <br />
      <span className="di-shine italic">dentro la rete</span>.
    </h2>

    <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {SEZIONI.map((s, i) => (
        <motion.div
          key={s.to}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
        >
          <Link
            to={s.to}
            data-testid={`section-card-${s.to.replace("/", "")}`}
            className="group block h-full overflow-hidden rounded-[24px] border border-[#E8E2E4] bg-white shadow-[0_8px_32px_rgba(94,42,82,0.05)] transition-transform duration-500 hover:-translate-y-1.5"
          >
            <div className="relative h-40 overflow-hidden">
              <img
                src={s.image}
                alt={s.titolo}
                className="h-full w-full object-cover transition-transform duration-[1400ms] group-hover:scale-[1.08]"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#3E1B36]/75 via-transparent to-transparent" />
              <span className="absolute left-5 top-5 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/85 text-[#5E2A52] backdrop-blur-md transition-colors duration-500 group-hover:bg-[#E0708A] group-hover:text-white">
                <s.icon size={16} />
              </span>
              <p className="absolute bottom-4 left-5 text-[10px] font-semibold uppercase tracking-[0.2em] text-white/80">
                {s.kicker}
              </p>
            </div>
            <div className="p-6">
              <h3 className="font-display text-2xl text-[#1A1617]">{s.titolo}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#6B5E62]">{s.testo}</p>
              <span className="mt-5 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-[#5E2A52]">
                Apri la pagina
                <ArrowRight
                  size={13}
                  className="transition-transform duration-300 group-hover:translate-x-1"
                />
              </span>
            </div>
          </Link>
        </motion.div>
      ))}
    </div>
  </section>
);
